var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66634 4.16663C2.12467 4.16663 2.49967 4.54163 2.49967 4.99996V15C2.49967 15.4583 2.12467 15.8333 1.66634 15.8333C1.20801 15.8333 0.833008 15.4583 0.833008 15V4.99996C0.833008 4.54163 1.20801 4.16663 1.66634 4.16663ZM4.99967 4.16663C5.45801 4.16663 5.83301 4.54163 5.83301 4.99996V15C5.83301 15.4583 5.45801 15.8333 4.99967 15.8333C4.54134 15.8333 4.16634 15.4583 4.16634 15V4.99996C4.16634 4.54163 4.54134 4.16663 4.99967 4.16663ZM18.333 4.16663H8.33301C7.87467 4.16663 7.49967 4.54163 7.49967 4.99996V15C7.49967 15.4583 7.87467 15.8333 8.33301 15.8333H18.333C18.7913 15.8333 19.1663 15.4583 19.1663 15V4.99996C19.1663 4.54163 18.7913 4.16663 18.333 4.16663ZM9.69967 13.4916L10.9247 11.9416C11.0913 11.7333 11.3997 11.7333 11.5747 11.9333L12.7413 13.3333L14.4913 11.075C14.658 10.8583 14.983 10.8583 15.1497 11.075L16.9913 13.4916C17.1997 13.7666 17.008 14.1583 16.658 14.1583H10.0247C9.68301 14.1666 9.48301 13.7666 9.69967 13.4916Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.7ccc1ac9.svg";
export { ForwardRef as ReactComponent };